import { render, staticRenderFns } from "./comparativo-productos.vue?vue&type=template&id=a73e8d8e&scoped=true&"
import script from "./comparativo-productos.vue?vue&type=script&lang=js&"
export * from "./comparativo-productos.vue?vue&type=script&lang=js&"
import style0 from "./comparativo-productos.vue?vue&type=style&index=0&id=a73e8d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73e8d8e",
  null
  
)

export default component.exports